import { IFragment } from "../interfaces/fragment";
import {
  IAllClientGuardLayouts,
  IAllWalletFragments,
} from "../interfaces/client-level-fragments";

export const useClientGuardScreenManager = (
  wallet: IAllWalletFragments,
  fragment: { rootId: string }
): [typeof rootId, typeof root, typeof selectedFragment] => {
  let selectedFragment: IFragment<IAllClientGuardLayouts> = null;
  selectedFragment = wallet?.__HACKY__CLIENT_GUARD;

  let root: IAllClientGuardLayouts = null;
  let rootId: string = null;
  if (selectedFragment) {
    rootId = selectedFragment.rootId;
    if (fragment && fragment.rootId) rootId = fragment.rootId;
    root = selectedFragment.byId[rootId];
  }

  return [rootId, root, selectedFragment];
};
